export default "__VITE_ASSET__DaUVSFnp__"